/* Raztechs cart page: live item count in the banner + "Complete the install" recommendations. */
(function () {
  var esc = function (s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; };
  var money = function (c) { return (c / 100).toLocaleString('en-US', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' }); };
  function refreshHero() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      var n = document.querySelector('[data-rc-count]'), t = document.querySelector('[data-rc-total]');
      if (n) n.textContent = c.item_count + ' item' + (c.item_count === 1 ? '' : 's');
      if (t) t.textContent = money(c.total_price);
      var sh = document.querySelector('[data-rc-ship]');
      if (sh) {
        var left = (+sh.dataset.threshold) - c.total_price;
        sh.classList.toggle('is-won', left <= 0);
        sh.querySelector('[data-rc-ship-text]').textContent = left <= 0 ? 'Free standard shipping unlocked' : money(left) + ' away from free shipping';
      }
      if (c.item_count === 0) location.reload();
    });
    // keep the hidden slide-out cart (incl. its free-shipping route) in sync: swap its whole inner panel
    if (document.querySelector('cart-drawer .drawer__inner')) {
      fetch('/cart?section_id=cart-drawer').then(function (r) { return r.text(); }).then(function (html) {
        var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('.drawer__inner');
        var cur = document.querySelector('cart-drawer .drawer__inner');
        if (fresh && cur) cur.replaceWith(fresh);
      });
    }
  }
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, refreshHero);

  var box = document.querySelector('[data-rc-recs]'), grid = document.querySelector('[data-rc-recs-grid]');
  if (!box || !grid) return;
  fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
    if (!cart.items.length) return;
    var inCart = {}; cart.items.forEach(function (i) { inCart[i.product_id] = 1; });
    var pid = cart.items[0].product_id;
    var get = function (intent) { return fetch('/recommendations/products.json?product_id=' + pid + '&limit=8&intent=' + intent).then(function (r) { return r.ok ? r.json() : { products: [] }; }); };
    return Promise.all([get('complementary'), get('related')]).then(function (r) {   // both at once: faster
      var seen = {}, list = [];
      (r[0].products || []).concat(r[1].products || []).forEach(function (p) { if (!inCart[p.id] && p.available && !seen[p.id]) { seen[p.id] = 1; list.push(p); } });
      return list;
    }).then(function (list) {
      list = list.slice(0, 4);
      if (!list.length) return;
      grid.innerHTML = list.map(function (p) {
        var img = p.featured_image ? p.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '$1$2') + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=500' : '';
        var v = p.variants && p.variants[0];
        return '<div class="rc-rec">' +
          '<a class="rc-rec__img" href="' + p.url + '">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</a>' +
          '<div class="rc-rec__body"><span class="rc-rec__brand">' + esc(p.vendor) + '</span>' +
          '<a class="rc-rec__title" href="' + p.url + '">' + esc(p.title) + '</a>' +
          '<div class="rc-rec__row"><strong>' + money(p.price) + '</strong>' +
          (v ? '<button type="button" class="rc-rec__add" data-variant="' + v.id + '">Add</button>' : '') + '</div></div></div>';
      }).join('');
      box.hidden = false;
      grid.addEventListener('click', function (e) {
        var b = e.target.closest('[data-variant]'); if (!b) return;
        b.disabled = true; b.textContent = 'Adding…';
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: +b.dataset.variant, quantity: 1 }) })
          .then(function () { location.reload(); });
      });
    });
  });
})();
